module.exports = __webpack_public_path__ + "img/fm.eeaa12a2.svg";